import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Mi gato es viejo, igual funciona?',
    answer: 'Sí, el instinto territorial no tiene edad.'
  }, {
    question: '¿Tengo que comprar productos de farmacia caros?',
    answer: 'No, te enseñamos qué buscar en el súper y qué evitar (spoiler: la lavandina es tu enemiga).'
  }, {
    question: '¿Qué pasa si tengo 3 gatos?',
    answer: 'El bono #1 incluye el mapa específico para hogares con múltiples gatos.'
  }, {
    question: '¿Es un libro físico?',
    answer: 'No, es un pack digital de descarga inmediata. Lo comprás ahora y lo aplicás en 5 minutos.'
  }];
  return <section className="w-full bg-[#FAFAF7] py-10 md:py-20 px-6" data-id="element-117">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-3xl mx-auto" data-id="element-118">
        <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-[#1C1C1C] mb-12 text-center" data-id="element-119">
          Preguntas frecuentes
        </h2>

        <div className="space-y-4" data-id="element-120">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.1
        }} className="bg-white rounded-lg overflow-hidden shadow-sm" data-id="element-121">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-[#E8F0E8]/30 transition-colors" data-id="element-122">
                <span className="font-['Playfair_Display'] text-xl font-semibold text-[#1C1C1C] pr-4" data-id="element-123">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-[#2D8C5A] flex-shrink-0 transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-124" />
              </button>
              <AnimatePresence data-id="element-125">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-126">
                    <div className="px-6 pb-6 text-[#1C1C1C]/80 leading-relaxed" data-id="element-127">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </motion.div>
    </section>;
}